import Vue from "vue";
import dateFormats, { DEFAULT_DATE_FORMAT } from "@/static/dateFormats";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

export const filterFormatDate = (value: string | Date): string => {
  if (!value) return "";
  return dayjs(value, dateFormats, false).format(DEFAULT_DATE_FORMAT);
};

Vue.filter("formatDate", filterFormatDate);
